<template>
    <div class="sa-card sa-fam-member" @click="$router.push('/appointments')">
        <div class="sa-card-list-box">
            <figure class="sa-avtar-sm">
                <img :src="familyMember.img || imgUrl" alt="Doctor" class="sa-img-cover sa-av-img">
            </figure>
            <div class="sa-doct-det">
                <h6 class="sa-f-size14 sa-app-size10">{{familyMember.name}}
                    <span class="sa-font-normal sa-patient-apt sa-d-block sa-app-size10">
                        <strong class="sa-f-size12 sa-app-size10">{{familyMember.appointments.count}} - </strong>
                        <span class="sa-apt sa-app-size8">{{familyMember.appointments.label}}</span>
                    </span>
                </h6>
            </div>
        </div>
        <span class="sa-marker">{{familyMember.relation}}</span>
        <hr>
        <div class="sa-d-f-sbetween sa-f-size12 sa-mb10" v-if="familyMember.booking.status">
            <span :style="{'color':familyMember.booking.color}">{{familyMember.booking.status}}</span>
            <span>{{familyMember.booking.time}}</span>
        </div>
        <div class="sa-text-right sa-f-size12" v-else>
            <span class="sa-red-text" v-if="familyMember.active == false">Inactive</span>
            <span class="sa-green-text" v-else>Active</span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['familyMember'],
    components: {},
    data() {
        return {
            imgUrl: 'https://img.litedev.com/images/unknown-avtar.png'
        }
    },
}
</script>
<style>
.sa-fam-member .sa-marker{background-color: #0DA4DB;}
</style>